<template>
    <v-container fluid class="pa-0">
        <v-row>
            <template v-if="label?.trim() !== ''">
                <v-col cols="12" sm="12" class="my-1">
                    <v-card outlined >
                        <v-card-text class="pa-2">
                            <v-container>
                                <v-row>
                                    <v-col cols="12" sm="12" class="pa-0">
                                    {{ label.trim() }}
                                    </v-col>
                                    <v-col cols="12" sm="6" class="pa-2">
                                        <date-filter
                                            v-model="dates.from"
                                            :clearable="clearable"
                                            :hide-details="true"
                                            :loading-data="loading"
                                            :label="$t('subOrder.from') | uppercase"
                                            :range="false"
                                            @input="closeDatePicker()"
                                        />
                                    </v-col>
                                    <v-col cols="12" sm="6" class="pa-2">
                                        <date-filter
                                            v-model="dates.to"
                                            :clearable="clearable"
                                            :hide-details="true"
                                            :loading-data="loading"
                                            :label="$t('subOrder.to') | uppercase"
                                            :range="false"
                                            @input="closeDatePicker()"
                                        />
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-col>
            </template>
            <template v-else>
                <v-col cols="12" sm="6">
                    <date-filter
                        v-model="dates.from"
                        :clearable="clearable"
                        :hide-details="true"
                        :loading-data="loading"
                        :label="$t('subOrder.from') | uppercase"
                        :range="false"
                        @input="closeDatePicker()"
                    />
                </v-col>
                <v-col cols="12" sm="6" class="pt-0 pt-sm-3 pt-md-3 pt-lg-3 pt-xl-3">
                    <date-filter
                        v-model="dates.to"
                        :clearable="clearable"
                        :hide-details="true"
                        :loading-data="loading"
                        :label="$t('subOrder.to') | uppercase"
                        :range="false"
                        @input="closeDatePicker()"
                    />
                </v-col>
            </template>
        </v-row>
    </v-container>
</template>

<script lang="js">
  import DateFilter from '@/components/DateFilter'
  import { EventBus } from '@/event-bus'

  export default {
    name: 'ODateRangeFilter',
    components: {
        DateFilter
    },
    props: {
        value: {
            type: Object ,
            required: true,
            default: ()=> {
                return {
                    from: '',
                    to: ''
                }
            }
        },
        label: {
            type: String,
            default: ''
        },
        loading: {
            type: Boolean,
            default: false,
        },
        clearable: {
            type: Boolean,
            default: true
        }
    },
  computed: {
        dates: {
            get () {
                return this.value
            },
            set (value) {
                this.$emit('input', value)
            }
        },
    },
    methods:  {
        closeDatePicker() {
            EventBus.$emit('closeDatePicker')
        },
    }
}
</script>